var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-item",class:!_vm.isActive ? 'item-collapse' : ''},[_c('div',{staticClass:"item-heading",on:{"click":_vm.click}},[_vm._t("heading")],2),_vm._v(" "),_c('div',{staticClass:"item-body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f2f8a2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/accordion/CollapsibleItem.vue
// module id = 69
// module chunks = 0 1